"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonCalendarWidgetImplementor = void 0;
const ko = __importStar(require("knockout"));
const CommonCalendarWidget_1 = __importDefault(require("./CommonCalendarWidget"));
const CalendarDataProvider_1 = __importDefault(require("./providers/CalendarDataProvider"));
const CalendarStringProvider_1 = __importDefault(require("./providers/CalendarStringProvider"));
const CalendarConstant_1 = __importStar(require("./constants/CalendarConstant"));
const getCalendarBaseState = () => (Object.assign({}, {
    calendarData: {
        preSelectedSlots: [],
        filteredCalendarModel: {},
        calendarKeysList: []
    },
    view: {
        container: null
    },
    stringsProvider: null,
    dataProvider: null,
    commonCalendar: null,
    isLoadInProgress: false,
    constants: CalendarConstant_1.default
}));
class CommonCalendarWidgetImplementor {
    constructor(calendarWidgetId) {
        const widgetContainerRef = document.querySelector('#' + calendarWidgetId);
        if (!calendarWidgetId || !widgetContainerRef) {
            throw new Error('Calendar widget id is not valid');
        }
        this.state = getCalendarBaseState();
        this.calendarWidgetId = calendarWidgetId;
        this.state.view.container = widgetContainerRef;
    }
    load(successCallback, failCallback) {
        if (typeof successCallback !== 'function' || typeof failCallback !== 'function') {
            throw new Error('Unexpected type: Expected Success and/or Error callbacks to be functions');
        }
        let loadStatus;
        try {
            loadStatus = this.loadWidget();
        }
        catch (error) {
            loadStatus = CalendarConstant_1.WidgetLoadStatus.Failure;
        }
        if (CalendarConstant_1.WidgetLoadStatus.Success === loadStatus) {
            successCallback.call(undefined, { isNoSlots: false });
        }
        else if (CalendarConstant_1.WidgetLoadStatus.NoSlots === loadStatus) {
            failCallback.call(undefined, { isNoSlots: true });
        }
        else {
            failCallback.call(undefined, { isNoSlots: false });
        }
        return this;
    }
    attachEventListeners(callBack, eventName) {
        if (this.state.commonCalendar === null) {
            throw new Error(`Calendar is not yet initialized`);
        }
        if (!eventName || typeof callBack !== 'function') {
            throw new Error(`Invalid inputs eventName => ${eventName} and callBack funtion=> ${callBack}`);
        }
        this.state.view.container.addEventListener(eventName, function (eventPayload) {
            callBack(eventName, eventPayload);
        });
    }
    changeCalendar(calendarKey) {
        if (calendarKey != undefined) {
            if (calendarKey !== this.state.dataProvider.getCurrentCalendarKey()) {
                this.state.dataProvider.changeCalendarKey(calendarKey);
                this.state.calendarData.filteredCalendarModel = null;
                this.loadCurrentCalendar();
            }
        }
    }
    selectSlotById(slotId) {
        if (slotId != undefined && slotId.length > 0) {
            this.state.commonCalendar.selectSlot(slotId);
        }
    }
    deSelectSlotById(slotId) {
        if (slotId != undefined && slotId.length > 0) {
            this.state.commonCalendar.deselectSlot(slotId);
        }
    }
    /**
     * Below methods are for querying on widget metadata
     */
    getCalendarWidgetId() {
        return this.calendarWidgetId;
    }
    /**
     * Below methods are for querying on widget metadata
     */
    getSlotDataById(slotId) {
        if (slotId != undefined && slotId.length > 0) {
            return this.state.dataProvider.getSlotData(slotId);
        }
        return null;
    }
    unregisterEventListeners() {
        if (this.state.commonCalendar != null) {
            const container = this.state.view.container;
            const eventsName = this.state.constants.eventsName;
            if (!container && eventsName) {
                for (var key in eventsName) {
                    if (eventsName[key] && eventsName.hasOwnProperty(key)) {
                        container.removeEventListener(eventsName[key]);
                    }
                }
            }
        }
    }
    loadWidget() {
        // do not load calendar passed container id is not available
        if (this.state.view.container == undefined) {
            return CalendarConstant_1.WidgetLoadStatus.Failure;
        }
        if (this.isNoSlotsView()) {
            return CalendarConstant_1.WidgetLoadStatus.NoSlots;
        }
        try {
            this.initCalendarData();
            this.initStringsProvider();
            this.state.commonCalendar = new CommonCalendarWidget_1.default(this.calendarWidgetId, this.state.stringsProvider);
            this.state.constants.eventsName = Object.assign({}, this.state.commonCalendar.eventsName);
            ko.cleanNode(this.state.view.container);
            this.unregisterEventListeners();
            this.state.calendarData.filteredCalendarModel = null;
            this.loadCurrentCalendar();
            return CalendarConstant_1.WidgetLoadStatus.Success;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    loadCurrentCalendar() {
        let calendarModel;
        let preSelectedSlots = [];
        if (!this.state.isLoadInProgress) {
            this.state.isLoadInProgress = true;
            calendarModel = this.state.dataProvider.getCurrentCalendarModel();
            preSelectedSlots = this.getActivePreSelectedSlots();
            this.state.commonCalendar.loadCalendar(calendarModel, preSelectedSlots, this.state.dataProvider.getCurrentCalendarKey());
        }
        this.updateCalendarVisibility(calendarModel);
        this.state.isLoadInProgress = false;
        if (preSelectedSlots.length > 0) {
            const dateIdOfFirstSlot = this.state.dataProvider.getDateIdBySlotId(preSelectedSlots[0]);
            this.state.commonCalendar.selectDate(dateIdOfFirstSlot);
        }
        this.state.calendarData.preSelectedSlots = null;
    }
    isNoSlotsView() {
        const noSlotsAlert = this.state.view.container.querySelectorAll(`.${this.state.constants.classes.calendarNoSlotsAlert}`);
        return (noSlotsAlert && noSlotsAlert.length > 0);
    }
    initCalendarData() {
        const constants = this.state.constants;
        const calendarModelsString = this.state.view.container.querySelector('.' + constants.classes.calendarModels).innerHTML;
        const calendarModelsJson = JSON.parse(calendarModelsString).calendars;
        this.state.dataProvider = new CalendarDataProvider_1.default(calendarModelsJson);
        ;
        this.state.calendarData.calendarKeysList = Object.keys(calendarModelsJson);
        if (this.state.calendarData.calendarKeysList.length > 0) {
            this.state.dataProvider.changeCalendarKey(this.state.calendarData.calendarKeysList[0]);
        }
        const selectedSlotsString = this.state.view.container.querySelector('.' + constants.classes.selectedSlots).innerHTML;
        this.state.calendarData.preSelectedSlots = JSON.parse(selectedSlotsString);
    }
    initStringsProvider() {
        const constants = this.state.constants;
        const stringsJsonDiv = this.state.view.container.querySelector('.' + constants.classes.calendarStrings).innerHTML;
        const stringsParsed = JSON.parse(stringsJsonDiv);
        this.state.stringsProvider = new CalendarStringProvider_1.default(stringsParsed);
    }
    updateCalendarVisibility(calendarModel) {
        const constants = this.state.constants;
        if (calendarModel && calendarModel.days.length === 0) {
            this.state.view.container.classList.add(constants.classes.elementHide);
        }
        else {
            this.state.view.container.classList.remove(constants.classes.elementHide);
        }
    }
    getActivePreSelectedSlots() {
        const preSelectedSlots = this.state.calendarData.preSelectedSlots || [];
        let activeSelectedSlotIds = [];
        preSelectedSlots.forEach(function (slotInfo) {
            if (slotInfo.slotStartTime != undefined) {
                let slotId = 's-' + slotInfo.slotStartTime;
                if (this.state.dataProvider.getSlotData(slotId).isActive) {
                    activeSelectedSlotIds.push(slotId);
                }
            }
        });
        return activeSelectedSlotIds;
    }
}
exports.CommonCalendarWidgetImplementor = CommonCalendarWidgetImplementor;
;
